import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { toast } from "@foris/avocado-suite";
import { groupEnrollmentRestrictionsMutation } from "../graphql/groupEnrollmentRestrictions.mutation";
import { EnrollmentRestrictionOperator } from "@models/ISchema";

interface UpdateGroupRestrictionsPayload {
  scenarioId: string;
  originId: string;
  groupId: string;
  dryRun?: boolean;
  skipValidations?: boolean;
  restrictions: {
    attribute: string;
    operator: EnrollmentRestrictionOperator;
    table: string;
    values: string[];
  }[];
}

interface useUpdateGroupRestrictionsProps {
  onSuccess?: () => void;
  onError?: () => void;
}

const useUpdateGroupRestrictions = (props?: useUpdateGroupRestrictionsProps) => {
  const { t } = useTranslation();
  const [updateGroupRestrictionsMutation, { loading }] = useMutation(
    groupEnrollmentRestrictionsMutation,
  );

  const handleUpdateGroupRestrictions = async (payload: UpdateGroupRestrictionsPayload) => {
    try {
      const variables = {
        scenarioId: payload.scenarioId,
        originId: payload.originId,
        input: {
          dryRun: payload.dryRun ?? false,
          skipValidations: payload.skipValidations ?? false,
          groupId: payload.groupId,
          restrictions: payload?.restrictions ?? [],
        },
      };

      const response = await updateGroupRestrictionsMutation({ variables });

      toast.success(t("group-restrictions.notifications.success-update"), {
        autoClose: 5000,
      });

      props?.onSuccess?.();

      return response;
    } catch (error) {
      console.error(error);
      toast.error(t("group-restrictions.notifications.error-update"), {
        autoClose: 5000,
      });
      props?.onError?.();
      return null;
    }
  };

  return {
    handleUpdateGroupRestrictions,
    isLoading: loading,
  };
};

export default useUpdateGroupRestrictions;
